/* RUEMOOD cookie choices (redesign 4 Nov 2026).
   Shows only where Shopify's Customer Privacy API says a banner is required (shouldShowBanner); if the API never loads,
   shows unless a stored choice exists. Stores rm_cc_prefs_v<version> = {necessary, analytics, marketing, preferences}
   (read by marketing-popup.js), sends every choice to Shopify.customerPrivacy.setTrackingConsent and fires
   the "rm:cookie-consent" event. Any element with [data-rm-cc-open] reopens the Manage view. */
(function () {
  'use strict';

  var API_TIMEOUT_MS = 4000;
  var CATS = ['analytics', 'marketing', 'preferences'];
  var root, cfg = { version: 1, policyUrl: '/policies/privacy-policy' };

  function readSettings() {
    try {
      var el = document.querySelector('[data-rm-cc-settings]');
      if (el) {
        var d = JSON.parse(el.textContent || '{}');
        if (d.version) cfg.version = d.version;
        if (d.policyUrl) cfg.policyUrl = d.policyUrl;
      }
    } catch (e) { /* keep defaults */ }
  }
  function key() { return 'rm_cc_prefs_v' + (cfg.version || 1); }
  function getStored() {
    try {
      var raw = localStorage.getItem(key());
      var v = raw ? JSON.parse(raw) : null;
      return v && typeof v === 'object' ? v : null;
    } catch (e) { return null; }
  }
  function store(prefs) { try { localStorage.setItem(key(), JSON.stringify(prefs)); } catch (e) {} }
  function makePrefs(a, m, p) { return { necessary: true, analytics: !!a, marketing: !!m, preferences: !!p }; }

  // Shopify Customer Privacy API, loaded once; cb(api|null). Falls back to null after API_TIMEOUT_MS.
  var apiState = 'idle', apiValue = null, apiWaiters = [];
  function withApi(cb) {
    var sh = window.Shopify;
    if (sh && sh.customerPrivacy && typeof sh.customerPrivacy.setTrackingConsent === 'function') return cb(sh.customerPrivacy);
    if (apiState === 'done') return cb(apiValue);
    apiWaiters.push(cb);
    if (apiState === 'loading') return;
    apiState = 'loading';
    var finish = function (api) {
      if (apiState === 'done') return;
      apiState = 'done'; apiValue = api || null;
      var w = apiWaiters; apiWaiters = [];
      w.forEach(function (fn) { try { fn(apiValue); } catch (e) {} });
    };
    setTimeout(function () { finish(null); }, API_TIMEOUT_MS);
    if (sh && typeof sh.loadFeatures === 'function') {
      try {
        sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          finish(!err && cp && typeof cp.setTrackingConsent === 'function' ? cp : null);
        });
      } catch (e) { finish(null); }
    } else {
      finish(null);
    }
  }

  function toShopify(prefs) {
    return { analytics: !!prefs.analytics, marketing: !!prefs.marketing, preferences: !!prefs.preferences, sale_of_data: !!prefs.marketing };
  }
  function sendToShopify(prefs, onlyIfDifferent) {
    withApi(function (api) {
      if (!api) return;
      var payload = toShopify(prefs);
      if (onlyIfDifferent && typeof api.currentVisitorConsent === 'function') {
        try {
          var cur = api.currentVisitorConsent() || {};
          var same = Object.keys(payload).every(function (k) { return cur[k] === (payload[k] ? 'yes' : 'no'); });
          if (same) return;
        } catch (e) { /* fall through and send */ }
      }
      try { api.setTrackingConsent(payload, function () {}); } catch (e) {}
    });
  }

  // Run <script type="text/plain" data-cc="analytics|marketing|preferences"> tags once their category is allowed.
  function enableQueuedScripts(prefs) {
    try {
      document.querySelectorAll('script[type="text/plain"][data-cc]:not([data-cc-executed])').forEach(function (s) {
        var cat = s.getAttribute('data-cc');
        if (!cat || !prefs[cat]) return;
        var t = document.createElement('script');
        ['async', 'defer', 'crossorigin', 'referrerpolicy', 'nonce'].forEach(function (a) {
          if (s.hasAttribute(a)) t.setAttribute(a, s.getAttribute(a));
        });
        var src = s.getAttribute('data-src') || s.getAttribute('src');
        if (src) t.src = src; else t.text = s.textContent || '';
        s.setAttribute('data-cc-executed', '1');
        s.replaceWith(t);
      });
    } catch (e) {}
  }
  function announce(prefs) {
    var accepted = CATS.some(function (k) { return prefs[k]; });
    document.dispatchEvent(new CustomEvent('rm:cookie-consent', { detail: Object.assign({ accepted: accepted }, prefs) }));
  }

  // View handling
  function q(sel) { return root.querySelector(sel); }
  function views() { return { main: q('[data-rm-cc-view="main"]'), manage: q('[data-rm-cc-view="manage"]') }; }
  function show() {
    root.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
  }
  function hide() { root.classList.remove('is-in', 'is-manage'); root.hidden = true; }
  function swap(to) {
    var v = views(), next = v[to];
    // Keep the card the same width when Manage replaces it (it only grows upward); phones are full width anyway.
    if (to === 'manage' && !root.hidden) root.style.width = root.getBoundingClientRect().width + 'px';
    else if (to === 'main') root.style.width = '';
    v.main.hidden = to !== 'main'; v.manage.hidden = to !== 'manage';
    root.classList.toggle('is-manage', to === 'manage');
    q('[data-rm-cc-manage]').setAttribute('aria-expanded', to === 'manage' ? 'true' : 'false');
    next.classList.remove('is-entering'); void next.offsetWidth; next.classList.add('is-entering');
  }
  function openManage() {
    var s = getStored() || makePrefs(false, false, false);
    CATS.forEach(function (k) { var i = q('[data-rm-cc-cat="' + k + '"]'); if (i) i.checked = !!s[k]; });
    if (root.hidden) show();
    swap('manage');
    var first = q('[data-rm-cc-cat]'); if (first) first.focus({ preventScroll: true });
  }
  function back() { swap('main'); var m = q('[data-rm-cc-manage]'); if (m) m.focus({ preventScroll: true }); }
  function choose(prefs) {
    store(prefs);
    sendToShopify(prefs, false);
    enableQueuedScripts(prefs);
    hide();
    swap('main');
    announce(prefs);
  }

  function bind() {
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-rm-cc-accept')) choose(makePrefs(true, true, true));
      else if (t.hasAttribute('data-rm-cc-essentials')) choose(makePrefs(false, false, false));
      else if (t.hasAttribute('data-rm-cc-manage')) openManage();
      else if (t.hasAttribute('data-rm-cc-back')) back();
      else if (t.hasAttribute('data-rm-cc-save')) {
        var v = {}; CATS.forEach(function (k) { var i = q('[data-rm-cc-cat="' + k + '"]'); v[k] = !!(i && i.checked); });
        choose(makePrefs(v.analytics, v.marketing, v.preferences));
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-manage')) { e.preventDefault(); back(); }
    });
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-rm-cc-open]');
      if (o) { e.preventDefault(); openManage(); }
    });
  }

  function init() {
    root = document.getElementById('rmCc');
    if (!root) return;
    readSettings();
    bind();
    var stored = getStored();
    if (stored) {
      // Returning visitor: keep Shopify in step with the stored choice (sent only if Shopify's record differs).
      sendToShopify(stored, true);
      enableQueuedScripts(stored);
      announce(stored);
      return;
    }
    withApi(function (api) {
      if (getStored()) return;
      if (!api || typeof api.shouldShowBanner !== 'function') { show(); return; }
      var need = true;
      try { need = !!api.shouldShowBanner(); } catch (e) { need = true; }
      if (need) show();
    });
  }

  window.RuemoodCookieConsent = { open: function () { if (root) openManage(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
